/* ICI PARIS XL theme scripts - carrosseis, drawer, acordeoes, wishlist */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    if (!drawer) return;
    function toggle(open) {
      drawer.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { toggle(true); });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { toggle(false); });
    });
    if (overlay) overlay.addEventListener('click', function () { toggle(false); });
  }

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    var track = root.querySelector('[data-hero-track]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (!track) return;
    var slides = track.children.length;
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '5', 10) * 1000;
    var timer = null;

    function go(i) {
      index = (i + slides) % slides;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      sync();
    }
    function sync() {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) { index = i; sync(); }
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(index + 1); restart(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });

    function start() { if (autoplay && slides > 1) timer = setInterval(function () { go(index + 1); }, speed); }
    function restart() { clearInterval(timer); start(); }
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    start();
    sync();
  }

  /* ---------- Generic carousel arrows ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  }

  /* ---------- USP rotator (mobile) ---------- */
  function initUsp(root) {
    var items = root.querySelectorAll('.usp-bar__item');
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  }

  /* ---------- Accordions (PDP / footer / SEO) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        head.closest('[data-accordion-item]').classList.toggle('is-open');
      });
    });
    document.querySelectorAll('[data-footer-col] h4').forEach(function (h) {
      h.addEventListener('click', function () {
        if (window.innerWidth < 768) h.parentElement.classList.toggle('is-open');
      });
    });
    document.querySelectorAll('[data-seo-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = document.querySelector(btn.getAttribute('data-seo-toggle'));
        if (!body) return;
        var open = body.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  function initWishlist() {
    var KEY = 'ipxl_wishlist';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      var id = btn.getAttribute('data-wish');
      if (list.indexOf(id) > -1) btn.classList.add('is-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pos = list.indexOf(id);
        if (pos > -1) { list.splice(pos, 1); btn.classList.remove('is-active'); }
        else { list.push(id); btn.classList.add('is-active'); }
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e2) {}
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = document.querySelector('[data-gallery-main]');
        if (main) main.src = t.getAttribute('data-full') || t.src;
      });
    });
  }

  /* ---------- PDP variant sync: preco, comparacao e disponibilidade ---------- */
  function initProductVariants(root) {
    var select = root.querySelector('[data-variant-select]');
    var dataEl = root.querySelector('[data-product-variants]');
    if (!select || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceEl = root.querySelector('[data-current-price]');
    var compareEl = root.querySelector('[data-current-compare]');
    var btn = root.querySelector('[data-atc-button]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyBtn = root.querySelector('[data-sticky-btn]');

    function apply(variant) {
      if (!variant) return;
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (compareEl) {
        if (variant.compare_at_price) {
          compareEl.textContent = variant.compare_at_price;
          compareEl.hidden = false;
          if (priceEl) priceEl.classList.add('money--sale');
        } else {
          compareEl.hidden = true;
          if (priceEl) priceEl.classList.remove('money--sale');
        }
      }
      [btn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !variant.available;
        b.textContent = variant.available
          ? b.getAttribute('data-label-available') || b.textContent
          : b.getAttribute('data-label-sold-out') || b.textContent;
      });
    }

    select.addEventListener('change', function () {
      var variant = variants.filter(function (v) { return String(v.id) === select.value; })[0];
      apply(variant);
    });
  }

  /* ---------- Carrinho: +/- e atualizacao automatica ---------- */
  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    // envia pelo botao "update" para que o parametro chegue ao Shopify
    function submitUpdate() {
      var updateBtn = form.querySelector('[name="update"]');
      if (updateBtn) updateBtn.click();
      else form.submit();
    }

    form.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('[data-qty-input]');
      if (!input) return;
      function step(delta) {
        var val = parseInt(input.value, 10);
        if (isNaN(val)) val = 0;
        input.value = Math.max(0, val + delta);
        submitUpdate();
      }
      var minus = box.querySelector('[data-qty-minus]');
      var plus = box.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
      input.addEventListener('change', submitUpdate);
    });
  }

  /* ---------- Barra fixa de compra (mobile) ---------- */
  function initStickyAtc(root) {
    var bar = root.querySelector('[data-sticky-atc]');
    var mainBtn = root.querySelector('[data-atc-button]');
    var stickyBtn = root.querySelector('[data-sticky-btn]');
    var sentinel = root.querySelector('[data-atc-sentinel]');
    if (!bar || !mainBtn || !stickyBtn) return;

    stickyBtn.addEventListener('click', function () { mainBtn.click(); });

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('has-sticky-atc', visible);
      });
      io.observe(sentinel);
    } else {
      bar.classList.add('is-visible');
      document.body.classList.add('has-sticky-atc');
    }
  }

  function boot() {
    initDrawer();
    initAccordions();
    initWishlist();
    initGallery();
    initCart();
    document.querySelectorAll('[data-hero]').forEach(initHero);
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-usp-bar]').forEach(initUsp);
    document.querySelectorAll('[data-product]').forEach(function (root) {
      initProductVariants(root);
      initStickyAtc(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
